/**
 * AI 사진 생성 관련 타입 정의
 * Note: AIStyle, AIGenerationStatus 등 Zod 기반 타입은 schemas/ai.ts에서 export
 */
export const AI_STYLES = [
    { value: 'CLASSIC_STUDIO', label: '클래식 스튜디오', description: '정석적인 스튜디오 화보' },
    { value: 'OUTDOOR_GARDEN', label: '야외 가든', description: '자연광 정원 로맨스' },
    { value: 'SUNSET_BEACH', label: '해변 일몰', description: '열대 해변 석양' },
    { value: 'TRADITIONAL_HANBOK', label: '전통 한복', description: '고궁/한옥 배경 혼례복' },
    { value: 'VINTAGE_CINEMATIC', label: '빈티지 영화', description: '50-60년대 필름 감성' },
    { value: 'LUXURY_HOTEL', label: '럭셔리 호텔', description: '샹들리에 호텔 볼룸' },
    { value: 'CITY_LIFESTYLE', label: '도시 스냅', description: '도심 스트릿 스냅' },
    { value: 'ENCHANTED_FOREST', label: '동화 숲', description: '몽환적인 숲속 요정' },
    { value: 'BLACK_AND_WHITE', label: '흑백 포트릿', description: '시대초월 흑백 감성' },
    { value: 'MINIMALIST_GALLERY', label: '미니멀리즘', description: '갤러리 아트 스타일' },
];
export const SNAP_TYPES = [
    {
        value: 'STUDIO',
        label: '스튜디오 스냅',
        description: '클래식한 실내 웨딩 화보',
        styles: ['CLASSIC_STUDIO', 'LUXURY_HOTEL', 'MINIMALIST_GALLERY', 'BLACK_AND_WHITE'],
    },
    {
        value: 'OUTDOOR',
        label: '야외 스냅',
        description: '자연광 속 로맨틱 야외 촬영',
        styles: ['OUTDOOR_GARDEN', 'SUNSET_BEACH', 'ENCHANTED_FOREST'],
    },
    {
        value: 'CONCEPT',
        label: '컨셉 스냅',
        description: '한복, 빈티지, 시티 등 테마 촬영',
        styles: ['TRADITIONAL_HANBOK', 'VINTAGE_CINEMATIC', 'CITY_LIFESTYLE'],
    },
];
export const PRESET_TAGS = ['베스트샷', '미공개', '인스타용', '청첩장용', '프로필'];
// ── Constants ──
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
//# sourceMappingURL=ai.js.map